import React from 'react';
import { Row, Col } from 'react-bootstrap';

/**
 * SectionTitle component displays a section title with a background and rounded corners.
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The content of the section title
 * @returns {JSX.Element} - JSX element representing the SectionTitle component
 */
export default function SectionTitle({ children }) {
  return (
    <Row className="mt-3 mb-3 p-2 pt-3 shadow-sm rounded bg-white">
      <Col>
        <h5>{children}</h5>
      </Col>
    </Row>
  );
}
